if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const attributes = { "_fromB2B": null };
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: {},  attributes }),
        });

        const formData = new FormData(this.form);
        const quantity = +formData.get('quantity') || 1;
        const currentVariantId = this.getAttribute('data-variant');
        const currentSubmitButton = this.querySelector(`[type="submit"][data-variant="${currentVariantId}"]`);
        const maxQuantity = +currentSubmitButton.getAttribute('data-inventory');
        const preorderMessage = currentSubmitButton?.getAttribute('data-message');
        const isRental = currentSubmitButton?.getAttribute('data-rental');
        const inventoryManagement = currentSubmitButton?.getAttribute('data-inventory-management')
        const newQuantity = +maxQuantity - (+quantity);
        const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        const errorMessageSpan = errorMessageWrapper.querySelector('.product-form__error-message');
        
        errorMessageSpan.textContent = '';
        errorMessageWrapper.setAttribute('hidden', true);

        if (quantity > maxQuantity && (preorderMessage == "" || preorderMessage == null) && inventoryManagement) {     
          const message = maxQuantity <= 0 ? '' : `Max quantity is ${maxQuantity}`;
          isRental ?   errorMessageSpan.innerHTML = `Maximum online quantity reached. <a href="https://yourreformer.com/pages/commercial#commercial-form">Contact us</a> for Business requests.` :
          errorMessageSpan.textContent = "You can't add more of this product to the cart." + message;
          errorMessageWrapper.removeAttribute('hidden');
          return;
        }


        
        if (currentSubmitButton.getAttribute('aria-disabled') === 'true') return;

        if (isRental) {
          const bundledProductInclusion = document.querySelector('#product-inclusions .inclusion-item-bundled-product');
          if (bundledProductInclusion) {
            const selectedVariant = bundledProductInclusion.querySelector('input[data-checked]')?.dataset.variant;
            if (!selectedVariant) {
              const errEl = document.getElementById('prop-kit-inclusion-error');
              const errMsg = document.getElementById('prop-kit-inclusion-error-msg');
              if (errEl && errMsg) {
                errMsg.textContent = 'Please select a color.';
                errEl.style.display = 'block';
              }
              bundledProductInclusion.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
          }
        }

        if (window.EducationCartRules?.isEnabled()) {
          const dataProduct = this.getAttribute('data-product');
          const cart = await EducationCartRules.fetchCart();
          const requiresShipping = currentSubmitButton.getAttribute('data-requires-shipping') === 'true';
          const validation = EducationCartRules.validateAddToCart(cart, {
            productId: dataProduct,
            variantId: String(currentVariantId),
            quantity,
            requiresShipping,
          });
          if (!validation.ok) {
            errorMessageSpan.textContent = validation.message;
            errorMessageWrapper.removeAttribute('hidden');
            return;
          }
        }

        this.handleErrorMessage();
        
        currentSubmitButton.setAttribute('aria-disabled', true);
        currentSubmitButton.classList.add('loading');
        currentSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = currentSubmitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              currentSubmitButton.setAttribute('aria-disabled', true);
              currentSubmitButton.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            currentSubmitButton.setAttribute('data-inventory', newQuantity);
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            let finalResponse = response;
            const bundledProductVariant = isRental
              ? document.querySelector('#product-inclusions .inclusion-item-bundled-product input[data-checked]')?.dataset.variant
              : null;
            if (bundledProductVariant) {
              await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: +bundledProductVariant, quantity: 1 }] })
              });
              const sectionIds = this.cart.getSectionsToRender().map(s => s.id);
              const freshRes = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: {}, sections: sectionIds })
              });
              finalResponse = await freshRes.json();
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(finalResponse);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(finalResponse);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            currentSubmitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) currentSubmitButton.removeAttribute('aria-disabled');
            currentSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}